/**
 * Feed page — Figma 38:904 "Без фильтров" surface.
 *
 * Route: /feed
 *
 * ACT-INDEEP-PRODUCTION-FEED-FIGMA-REPAIR01 (Phase D)
 *
 * Composition:
 *   - FeedTopBar (Figma 38:983 title, 38:985 subtitle, 38:986 compose)
 *   - FeedList (GET /api/v1/feed/, native <ul>, async UI states)
 *
 * The local FEED_SEED fixture was REMOVED in Phase D; posts are now
 * sourced exclusively from the live list endpoint via
 * `listFeedPostsAdapter`. The fixture had outlived its purpose once
 * the API contract became authoritative, and a hard-coded local
 * fixture that lived alongside a live list adapter is a paper-RED
 * risk (the UI would render the fixture even when the API was
 * unreachable, masking production failures).
 *
 * The wrapper element keeps `data-testid="feed-page"` so pre-Phase-D
 * Playwright assertions that target either `feed-page` or `feed-list`
 * (see expectCanonicalFeedShell) continue to work — see the
 * `feed-page.or(feedList).first()` selector pair in the e2e spec.
 */
import { FeedTopBar } from '@/features/feed-top-bar/FeedTopBar';
import { FeedList } from '@/features/feed/FeedList';
import '@/features/feed/FeedPostCard.css';

export function FeedPage(): JSX.Element {
  return (
    <div className="feed-page" data-testid="feed-page">
      <FeedTopBar />
      <FeedList />
    </div>
  );
}